import swimming from "./Freestyle_swimming.gif";
export default function Loading() {
    return (
        <div>
            <img src={swimming} alt="Frisim" />
        </div>
    );
}
